import Sentry from '@shared/services/Sentry'

// Cache user lookup per load, as it is expensive
let cachedPromise = null
let cachedToken = null

export default {
  methods: {
    async getUserProfile() {
      // 1) Cache bust if token changed
      const token = this.$store?.getters?.authToken || null
      if (cachedToken !== token) {
        cachedToken = token
        cachedPromise = null
      }

      // 2) Fast path from Vuex
      try {
        const vuexUser = this.$store?.getters?.userProfile
        if (vuexUser && (vuexUser.id || (Array.isArray(vuexUser.roles) && vuexUser.roles.length))) {
          return vuexUser
        }
      } catch (_) {}
      
      // Check promise cache or set it
      if (!cachedPromise) {
        cachedPromise = this.$request({
          method: 'get',
          url: '/api/user/current',
        }).catch(err => {
          cachedPromise = null
          throw err
        })
      }

      const { data } = await cachedPromise
      data.appRoles = data?.appRoles || []
      data.groupRoles = data?.groupRoles || []

      // Set user in Sentry for future use in Replays
      try {
        Sentry.setUser(Sentry.toSentryUser(data))
      } catch (e) {
        console.error(e)
      }

      // Set user in GA4 for future use in Analytics
      try {
        const gtag = this.$gtag || this.$ga
        if (gtag) {
          gtag.set({ 'userId': data?.username })
          gtag.set({ 'user_id': data?.username })
        }
      } catch (e) {
        console.error(e)
      }

      // Merge manually assigned roles and group assigned roles
      data.roles = Array.from(
        new Set([
          ...data.appRoles.map(a => a.appRole.name),
          ...data.groupRoles.map(g => g.name),
        ])
      )

      // ✅ Make roleContains and other consumers work automatically
      // ✅ only set this.user if it already exists (some components still declare it)
      if (this && Object.prototype.hasOwnProperty.call(this, 'user')) {
        this.user = data
      }

      // Commit to Vuex so roleContains can use $store.getters.userProfile
      try {
        this.$store?.commit?.('userProfile', data)
      } catch (_) {}

      return data
    },

    async getLicenseFilter(fieldName = 'synchroLocationId') {
      const user = await this.getUserProfile()
      if (user.allowAllLocations) {
        return
      }
      const locationIds = user
        .locations
        .map(l => l.locationId)
      const filter = [[fieldName, '=', locationIds.shift()]]
      for (const locationId of locationIds) {
        filter.push('or', [fieldName, '=', locationId])
      }
      return filter
    },

    async getLocationFilter(fieldName = 'coreLocationId') {
      const user = await this.getUserProfile()
      if (user.allowAllLocations) {
        return
      }
      const coreLocationIds = user
        .locations
        .map(l => l.location.coreLocationId)
      const locationIds = Array.from(new Set(coreLocationIds))
      const filter = [[fieldName, '=', locationIds.shift()]]
      for (const locationId of locationIds) {
        filter.push('or', [fieldName, '=', locationId])
      }
      return filter
    },
  },
}
